export const pickTopCounts = (obj, limit) => {
  const entries = Object.entries(obj || {})
    .map(([k, v]) => [k, Number(v)])
    .filter(([, n]) => Number.isFinite(n));
  return entries.sort((a, b) => b[1] - a[1]).slice(0, limit);
};
